export default __webpack_public_path__ + "static/media/pin_darkblue.241a70ee.svg";